export default __webpack_public_path__ + "static/media/image_2.f81586ad.jpg";